import { createContext } from "react";

const MediaManagerContext = createContext({});

export default MediaManagerContext;
